import { darken } from 'polished'
import styled, { css } from 'styled-components'
import fadeIn from '../../styles/animations/fadeIn'
import ripple from '../../styles/animations/ripple'

interface FieldProps {
  readonly error: boolean
  background?: string
  small?: boolean
  gray?: boolean
}

export const Container = styled.div`
  ${fadeIn};
  height: 100%;
`

export const Field = styled.input<FieldProps>`
  -webkit-appearance: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.input || '#0f172a'};
  height: ${({ small }) => (small ? '36px' : '44px')};
  font-weight: 500;
  transition: border-color 200ms linear;
  background: ${({ background }) => (background ? background : 'transparent')};
  border: none;
  width: 100%;

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #94a3b8;
  }

  ${({ error }) =>
    error &&
    css`
      border-color: ${({ theme }) => theme.colors.error};

      &:hover {
        border-color: ${({ theme }) => darken(0.2, theme.colors.error)};
      }
    `};

  ${({ gray }) =>
    gray &&
    css`
      background-color: #f1f5f9;
      padding: 0px 10px;
      border-radius: 8px;
    `}
`

export const Content = styled.div<any>`
  position: relative;
  border-radius: 8px;
  gap: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0px 12px;
  background: ${({ background }) => (background ? background : 'rgba(255, 255, 255, 0.5)')};
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.25);
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary || '#2c30af'};
    box-shadow: 0 0 0 3px rgba(44, 48, 175, 0.15);
  }

  img {
    margin: auto;
    width: 20px;
    height: 20px;
  }
  color: ${({ theme }) => theme.colors.input || '#0f172a'};
`
export const ImageEdit = styled.div`
  ${ripple}
  cursor: pointer;
  position: absolute !important;
  bottom: -10px;
  right: -10px;
`

export const Label = styled.label<any>`
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #334155;
`

export const Error = styled.span`
  color: ${({ theme }) => theme.colors.error || '#ef4444'};
  font-size: 12px;
  margin-top: 4px;
`
